var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { load, loadAll, LoadingStateDefaults } from "framework/state/loader";
import { apiPutUIContext } from "./endpoint";
import { MemberUIContextDefaults, EmailUIContextDefaults, EventPlanningUIContextDefaults, CookieConsentUIContextDefaults, AdminWebCredentialsUIContextDefaults, EventRegistrationUIContextDefaults } from "./entity";
import { intoApiTransportDate } from "framework/http/transport";
import { UrlPathOfApiLocation } from "common/paths";
import { NoEntityError } from "framework/validation/validatableentity";
import { createSelector } from "react-sweet-state";
import { create } from "framework/http/endpoint";
import { create as createRequest } from "framework/http/rest/jsonRequest";
var UsersApiUri = "".concat(UrlPathOfApiLocation, "/api/users");
var LoginStateDefaults = __assign(__assign({}, LoadingStateDefaults), { open: false, invalid: false, entity: {
        email: "",
        password: ""
    }, errors: __assign({}, NoEntityError) });
var UIContextStateDefaults = __assign(__assign({}, LoadingStateDefaults), { data: {
        logged_user: null,
        cookie_consent: __assign({}, CookieConsentUIContextDefaults),
        member: __assign({}, MemberUIContextDefaults),
        is_known_email: __assign({}, EmailUIContextDefaults),
        event_planning: __assign({}, EventPlanningUIContextDefaults),
        event_registration: __assign({}, EventRegistrationUIContextDefaults),
        admin_web_credentials: __assign({}, AdminWebCredentialsUIContextDefaults),
    } });
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { uicontext: UIContextStateDefaults, login: LoginStateDefaults });
// Login
function apiUserLogin(loginData) {
    var uri = "".concat(UsersApiUri, "/login");
    var request = createRequest(loginData);
    return create(uri, request);
}
function apiUserLogout() {
    var uri = "".concat(UsersApiUri, "/logout");
    var request = createRequest(null);
    return create(uri, request);
}
var loginUser = function () { return function (store) {
    var loader = function () { return apiUserLogin(store.getState().login.entity); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            if (response.succeeded) {
                draft.login.entity.email = '';
                draft.login.entity.password = '';
                draft.login.invalid = false;
                draft.login.open = false;
            }
            else {
                draft.login.invalid = true;
            }
        });
        store.dispatch(initializeUIContext());
    };
    load(store, loader, stateProducer, function (s) { return s.login; });
}; };
var logoutUser = function () { return function (store) {
    var loader = function () { return apiUserLogout(); };
    var stateProducer = function (store, _, response) {
        store.dispatch(cleanUIContextOnLogout());
    };
    load(store, loader, stateProducer, function (s) { return s.login; });
}; };
var loginDialogFieldSetter = function (field, value) { return function (store) {
    store.setState(function (draft) {
        if (field === 'email') {
            draft.login.entity.email = value;
        }
        if (field === 'password') {
            draft.login.entity.password = value;
        }
    });
}; };
var openLoginDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.login.open = true;
    });
}; };
var closeLoginDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.login.open = false;
    });
}; };
// UIContext
var createEmptyContextQuery = function () {
    return {
        data: {}
    };
};
var createMemberContextQuery = function (idt) {
    return {
        data: {
            member: {
                id: idt
            }
        }
    };
};
var createIsKnownEmailContextQuery = function (email) {
    return {
        data: {
            is_known_email: {
                email: email
            }
        }
    };
};
var createEventPlanningContextQuery = function (eventId) {
    return {
        data: {
            event_planning: { eventId: eventId }
        }
    };
};
var createEventRegistrationContextQuery = function (eventType, id) {
    return {
        data: {
            event_registration: { eventType: eventType, id: id }
        }
    };
};
var createEventRegistrationContextQueryWithDate = function (date) {
    return {
        data: {
            event_registration: { date: intoApiTransportDate(date) }
        }
    };
};
var createAdminWebCredentialsContextQuery = function () {
    return {
        data: {
            admin_web_credentials: {}
        }
    };
};
var initializeUIContext = function () { return function (store) {
    var loader = function () { return apiPutUIContext(createEmptyContextQuery()); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var cleanUIContextOnLogout = function () { return function (store) {
    store.setState(function (draft) {
        draft.uicontext.data.logged_user = null;
        // cookie_consent is kept as it is
        draft.uicontext.data.member = __assign({}, MemberUIContextDefaults);
        draft.uicontext.data.is_known_email = __assign({}, EmailUIContextDefaults);
        draft.uicontext.data.event_planning = __assign({}, EventPlanningUIContextDefaults);
        draft.uicontext.data.event_registration = __assign({}, EventRegistrationUIContextDefaults);
        draft.uicontext.data.admin_web_credentials = __assign({}, AdminWebCredentialsUIContextDefaults);
    });
}; };
var loadMemberUIContext = function (idt) { return function (store) {
    var loader = function () { return apiPutUIContext(createMemberContextQuery(idt)); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
                draft.uicontext.data.member = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.member;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var loadKnownEmailUIContext = function (email) { return function (store) {
    var loader = function () { return apiPutUIContext(createIsKnownEmailContextQuery(email)); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
                draft.uicontext.data.is_known_email = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.is_known_email;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var loadEventPlanningUIContext = function (eventId) { return function (store) {
    var loader = function () { return apiPutUIContext(createEventPlanningContextQuery(eventId)); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
                draft.uicontext.data.event_planning = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.event_planning;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var loadEventRegistrationUIContext = function (eventType, id) { return function (store) {
    var loader = function () { return apiPutUIContext(createEventRegistrationContextQuery(eventType, id)); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
                draft.uicontext.data.event_registration = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.event_registration;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var loadEventRegistrationUIContextWithDate = function (date) { return function (store) {
    var loader = function () { return apiPutUIContext(createEventRegistrationContextQueryWithDate(date)); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
                draft.uicontext.data.event_registration = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.event_registration;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var loadAdminWebCredentialsUIContext = function () { return function (store) {
    var loader = function () { return apiPutUIContext(createAdminWebCredentialsContextQuery()); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.uicontext.data.logged_user = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.logged_user;
                draft.uicontext.data.cookie_consent = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cookie_consent;
                draft.uicontext.data.admin_web_credentials = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.admin_web_credentials;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.uicontext; });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        // UIContext
        initializeUIContext: initializeUIContext,
        loadMemberUIContext: loadMemberUIContext,
        loadKnownEmailUIContext: loadKnownEmailUIContext,
        loadEventPlanningUIContext: loadEventPlanningUIContext,
        loadEventRegistrationUIContext: loadEventRegistrationUIContext,
        loadEventRegistrationUIContextWithDate: loadEventRegistrationUIContextWithDate,
        loadAdminWebCredentialsUIContext: loadAdminWebCredentialsUIContext,
        // Login
        loginUser: loginUser,
        logoutUser: logoutUser,
        openLoginDialog: openLoginDialog,
        closeLoginDialog: closeLoginDialog,
        loginDialogFieldSetter: loginDialogFieldSetter,
    },
    name: "UIContext"
});
var useState = createHook(store);
// UIContext substore
var getUIContextState = createSelector(function (state) { return state.uicontext; }, function (__, props) { return null; }, function (uicontext, __) { return uicontext; });
var useUIContext = createHook(store, {
    selector: getUIContextState,
});
// UIContext substore
var getLoginState = createSelector(function (state) { return state.login; }, function (__, props) { return null; }, function (login, __) { return login; });
var useLogin = createHook(store, {
    selector: getLoginState,
});
export { useState as useUIContextAndLogin, useUIContext, useLogin, createEventPlanningContextQuery, };
